import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import {
  ClockInModel,
  ClockOutModel,
} from 'app/store/timesheet/timesheet.model';
import { hashConfig } from 'app/utils/config/hash.config';

@Injectable({
  providedIn: 'root',
})
export class TimesheetService {
  constructor(private baseService: BaseService) {}

  clockIn(payload: ClockInModel): Observable<any> {
    return this.baseService.post(`kiosk/timesheet/attendance`, payload);
  }

  clockOut(payload: ClockOutModel): Observable<any> {
    return this.baseService.put(
      `kiosk/timesheet/attendance/${hashConfig.encrypt(payload.timesheetID)}`,
      payload
    );
  }

  timesheetLogs(): Observable<any> {
    return this.baseService.get(`kiosk/timesheet/logs`);
  }

  upload(body: FormData): Observable<any> {
    return this.baseService.post(`kiosk/file/upload`, body);
  }
}
